import { createSelector } from 'reselect'
import createPaymentScheduleSelector from './createPaymentScheduleSelector'
import { PAYMENT_SCHEDULE_TYPE, STATIC_PAYMENT_SCHEDULE_TEMPLATE_ID } from 'constants/payment'
import type { StaticPaymentScheduleOption } from 'constants/payment'
import { getReserveForZeroPaymentScheduleRequestInfo } from './reserveForZeroPaymentSchedule'
import { getSpoofHotelTwentyPercentPaymentScheduleRequestInfo } from './spoofHotelTwentyPercentPaymentSchedule'
import { getCustomOfferV2ScheduleRequestInfo } from './customOfferV2Schedule'
import {
  isLpc50DepositExperimentControlSuppressesSchedules,
  isLpc50DepositExperimentVariantForces50Schedule,
} from './lpc50PercentDepositPaymentSchedule'
import {
  isLpp50DepositExperimentControlSuppressesSchedules,
  isLpp50DepositExperimentVariantForces50Schedule,
} from './lpp50PercentDepositPaymentSchedule'

const offerStaticPaymentScheduleRequestInfo = createPaymentScheduleSelector(PAYMENT_SCHEDULE_TYPE.STATIC)

const getStaticPaymentScheduleOptions = createSelector(
  offerStaticPaymentScheduleRequestInfo,
  getSpoofHotelTwentyPercentPaymentScheduleRequestInfo,
  getReserveForZeroPaymentScheduleRequestInfo,
  getCustomOfferV2ScheduleRequestInfo,
  (state: App.State) => isLpc50DepositExperimentVariantForces50Schedule(state),
  (state: App.State) => isLpc50DepositExperimentControlSuppressesSchedules(state),
  (state: App.State) => isLpp50DepositExperimentVariantForces50Schedule(state),
  (state: App.State) => isLpp50DepositExperimentControlSuppressesSchedules(state),
  (offerInfo, spoofHotelTwentyPercentInfo, reserveForZeroInfo, customOfferInfo, lpc50VariantForces50, lpc50ControlSuppresses, lpp50VariantForces50, lpp50ControlSuppresses): Array<StaticPaymentScheduleOption> => {
    if (lpc50ControlSuppresses || lpp50ControlSuppresses) {
      return []
    }
    if ((lpc50VariantForces50 || lpp50VariantForces50) && offerInfo?.templateId === STATIC_PAYMENT_SCHEDULE_TEMPLATE_ID) {
      return [{ id: offerInfo.templateId, requestInfo: offerInfo }]
    }

    const options: Array<StaticPaymentScheduleOption> = []
    const seen = new Set<string>()

    for (const info of [offerInfo, spoofHotelTwentyPercentInfo, reserveForZeroInfo, customOfferInfo]) {
      if (info && !seen.has(info.templateId)) {
        seen.add(info.templateId)
        options.push({ id: info.templateId, requestInfo: info })
      }
    }

    return options
  },
)

export default getStaticPaymentScheduleOptions
